module.exports = __webpack_public_path__ + "static/about-thisiscara-1-008753f72bff0cb2a896b16fb63101fc.png";